module.exports = __webpack_public_path__ + "static/media/22555749_1629544243787427_2042355124576656817_o.6bd153f7.jpg";